import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { Role, RoleRepository } from 'app/services/database/role.repository';
import { ErrorWithResourceKey } from 'app/shared/errorWithResourceKey';

@Injectable()
export class IsSuperadminAuthGuard implements CanActivate, CanActivateChild {
    constructor(private authService: AuthService, private roleRepository: RoleRepository, private router: Router) { }

    public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return await this.guard(state);
    }

    public async canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return await this.guard(state);
    }

    private async guard(state: RouterStateSnapshot) {
        let user = await this.authService.getCurrentUser();
        let role = await this.roleRepository.get(user.uid);

        if (role === Role.SuperAdmin) return true;
        else {
            // We do that so that the error is handled by the global error handler.
            setTimeout(() => {
                throw new ErrorWithResourceKey('NotSuperadminError', 'This user is not a superadmin.', 'errors.insufficient-rights');
            }, 0);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/authGuards/isSuperadmin.authGuard.ts